import { Box } from '@mui/material';
import { useEffect, useRef } from 'react';
import classes from './QuestionComponent.module.scss';


const QuestionComponent = ({ question, answer, addHeights, height }) => {
  const boxRef = useRef();
  useEffect(() => {
    addHeights(boxRef.current.clientHeight);
    return () => null;
  }, [ question ]);
  return (
    <Box ref={boxRef} height={height} className={classes.main}>
      <Box className={classes.question} component={'h4'}>{question}</Box>
      <Box className={classes.answer} component={'p'}>{answer}</Box>
    </Box>
  );
};

export default QuestionComponent;
